import { ApiMsgTypes } from "@/api/AppApi/common-interfaces/IResultStamp";
import {
  useGetCartQuery,
  useManageCartItem,
  useRemoveCartItem,
} from "@/api/AppApi/services/cart";
import {
  CartItemTypes,
  IGetCart,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { ITimeSlotDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";
import { adaptFieldsToPost } from "@/app/components/common-form-builder/form-builder-helpers/form-functions";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import {
  debounce,
  getCartId,
  isSlotInCart,
} from "@/app/components/pages-components/cart/cart-functions";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { currencyAtom } from "@/hooks/currencyAtom";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { PagesPaths, forceItemInPage } from "@/utils/functions/pages-paths";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import SvgAppointmentGo from "../day-appointments-icons/SvgAppointmentGo";
import SvgAppointmetCart from "../day-appointments-icons/SvgAppointmetCart";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import BtnQuantitySelector from "@/app/components/pages-components/product-details-page/details-belpers/details-add-to-cart-btn/btn-quantity-selector/BtnQuantitySelector";
import NotFieldErrModal from "@/app/components/common-form-builder/form-builder-helpers/NotFieldErrModal";

enum AppointmentStates {
  addToCart = "addToCart",
  added = "added",
  booked = "booked",
}

interface Props {
  slot: ITimeSlotDetails;
  beside: boolean;
  agreeTerms: boolean;
  form: UseFormReturn<FieldValues, any>;
  productId: number;
  redirectToCheckout: boolean;
  productState?: IuseProductHasAttrsResult;
}
const TimeSlotBtn: React.FC<Props> = ({
  slot,
  beside,
  agreeTerms,
  form,
  productId,
  redirectToCheckout,
  productState,
}) => {
  const [quantity, setQuantity] = useState(0);
  const [isSignedIn] = useAtom(isSignedInAtom);
  const [currency] = useAtom(currencyAtom);
  const { eventTrackers } = useEventTrackers();
  const [resultMsg, setResultMsg] = useState();
  const router = useRouter();
  const t = useTranslation();
  const getCart = useGetCartQuery();
  const cartItems = getCart?.data?.result?.items;
  const { push } = useRouter();
  const itemId =
    getCartId(cartItems ?? [], slot?.id ?? 0) ?? 0;
  const item = cartItems?.find((item) => item.id === itemId)!;
  const manageCartApi = useManageCartItem({
    onSuccess: (res: IGetCart) => {
      const { items, coupon } = res.result ?? {};
      if (res?.message?.type === ApiMsgTypes.success) {
        const addedItem = items.find((item) => item.inner_id === slot.id)!;
        eventTrackers(EventType.ADD_CART, [addedItem], {
          currency: currency?.code,
          value: addedItem.price,
          coupon: coupon?.code ?? "",
          discount: addedItem.discount,
        });
        if (redirectToCheckout) {
          router.push(
            isSignedIn ? PagesPaths.userCheckout : PagesPaths.checkout,
          );
        }
      }
    },
    onError: (error) => {
      setResultMsg(error.response.data.message.text ?? error.message.text);
      console.log(error);
    },
  });

  const removeItemApi = useRemoveCartItem({
    onSuccess: (res) => {
      if (res?.message?.type === ApiMsgTypes.success) {
      }
    },
    onError: (error) => console.log(error),
  });

  const appointmentStatus = slot?.appointment_id
    ? AppointmentStates.booked
    : isSlotInCart(cartItems ?? [], slot)
    ? AppointmentStates.added
    : AppointmentStates.addToCart;

  const disableBtn =
    appointmentStatus === AppointmentStates.addToCart && !agreeTerms;
  const btn = () => {
    // if (!appointmentStatus) return;
    switch (appointmentStatus) {
      case AppointmentStates.addToCart:
        return {
          type: beside ? BtnTypes.primary : BtnTypes.secondary,
          label: t.book_now,
          svg: <SvgAppointmentGo />,
          loading: manageCartApi.isLoading,
        };
      case AppointmentStates.added:
        return {
          type: !beside ? BtnTypes.primary : BtnTypes.secondary,
          label: t.added,
          svg: <SvgAppointmetCart />,
          loading: removeItemApi.isLoading,
        };
      case AppointmentStates.booked:
        return {
          type: !beside ? BtnTypes.primary : BtnTypes.secondary,
          label: t.view_details,
          svg: <></>,
          loading: false,
        };
    }
  };

  const onClick = () => {
    switch (appointmentStatus) {
      // case AppointmentStates.addToCart:
      //   manageCartApi.mutate({
      //     cartId: undefined,
      //     type: CartItemTypes.slot,
      //     id: slot.id,
      //     quantity: 1,
      //     date: slot.date,
      //     note: "",
      //   });
      //   return;
      case AppointmentStates.added:
        const itemId =
          getCartId(cartItems ?? [], slot?.id ?? 0) ?? 0;
        const item = cartItems?.find((item) => item.id === itemId)!;
        removeItemApi.mutate(itemId);
        eventTrackers(EventType.remove_from_cart, [item], {
          discount: item.discount,
          tax: item.tax,
          value: item.price,
          currency: currency?.code,
        });
        return;
      case AppointmentStates.booked:
        push(forceItemInPage(PagesPaths.applications, slot.appointment_id!));
        return;
    }
  };
  const handleChangeQuantities = (quantity: number) => {
    setQuantity(quantity);
    if (quantity === 0) {
      removeItemApi.mutate(itemId);
      eventTrackers(EventType.remove_from_cart, [item], {
        discount: item.discount,
        tax: item.tax,
        value: item.price,
        currency: currency?.code,
      });
    } else {
      debounce(
        manageCartApi.mutate({
          cartId: itemId,
          type: CartItemTypes.slot,
          id: slot.id,
          quantity: quantity,
          date: slot.date,
          addons: item.addons,
          note: item.note,
          other_inputs: item.others.data_fields,
          product_id: productState?.currentProd?.id || productId,
        }),
        300,
      );
    }
  };

  useEffect(() => {
    if (!item) return;
    setQuantity(item?.quantity);
  }, [item, resultMsg]);
  return (
    <>
      {resultMsg && (
        <NotFieldErrModal
          errors={[resultMsg]}
          setErrors={() => setResultMsg(undefined)}
        />
      )}
      {appointmentStatus === AppointmentStates.added &&
      slot.allow_multiple_quantity ? (
        <BtnQuantitySelector
          minQuantity={0}
          quantity={quantity}
          setQuantity={handleChangeQuantities}
          plusDisabled={false}
          addedToCart={true}
        />
      ) : (
        <CustomButton
          type={btn()?.type}
          size={BtnSizes.small}
          radius={BtnRadius.small}
          onClick={
            appointmentStatus === AppointmentStates.addToCart
              ? form.handleSubmit((data, e) => {
                  e?.stopPropagation();
                  const other_inputs = adaptFieldsToPost(data);
                  manageCartApi.mutate({
                    cartId: undefined,
                    type: CartItemTypes.slot,
                    id: slot.id,
                    quantity: 1,
                    date: slot.date,
                    addons: Object.values(
                      productState?.selectedAddOns || {},
                    ).flat(),
                    note: "",
                    ...other_inputs,
                    product_id: productState?.currentProd?.id || productId,
                  });
                })
              : onClick
          }
          disabled={disableBtn}
          notAllowed={disableBtn}
        >
          {btn()?.loading ? (
            <SpinnerForBtn />
          ) : (
            <>
              {appointmentStatus === AppointmentStates.addToCart ? (
                <>
                  {btn()?.label}
                  {btn()?.svg}
                </>
              ) : (
                <>
                  {btn()?.svg} {btn()?.label}
                </>
              )}
            </>
          )}
        </CustomButton>
      )}
    </>
  );
};

export default TimeSlotBtn;
